import { createSlice } from '@reduxjs/toolkit';

export enum Status {
    SUCCESS,
    WARN,
    ERROR
};

interface InfoCardState {
    visible: boolean;
    status: Status;
    textAnts: string;
    subtitle: string;
    date: string;
    text: string;
    plan: string;
    state: string;
}

const initialState: InfoCardState = {
    visible: false,
    status: Status.WARN,
    textAnts: '',
    subtitle: '',
    date: '',
    text: '',
    plan: '',
    state: '',
};

export const statusConfirmationSlice = createSlice({
    name: 'statusConfirmation',
    initialState,
    reducers: {
        setSatusConfirmation: (state, action) => {
            return {
                ...state,
                ...action.payload
            };
        },
        clearStatusConfirmation: (state) => {
            return { ...initialState };
        },
        setVisibleFalse: (state) => {
            state.visible = false;
        }
    },
});

export const getStatusConfirmationData = (state: any) => state.statusConfirmation;

export const { setSatusConfirmation, clearStatusConfirmation, setVisibleFalse } = statusConfirmationSlice.actions;

export default statusConfirmationSlice.reducer;
